import React from 'react';
import { GraduationCap, User, TrendingUp, Award, Calendar, BarChart2 } from 'lucide-react';
import { RoadmapTier } from './RoadmapTier';
import { motion } from 'framer-motion';
export function Roadmap() {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    delay: 0.3
  }} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden mb-6" data-id="element-308">
      <div className="bg-gray-50 border-b border-gray-200 px-6 py-4" data-id="element-309">
        <h2 className="text-xl font-extrabold text-[#0a1e5e] flex items-center gap-2" data-id="element-310">
          <TrendingUp className="w-6 h-6 text-blue-600" data-id="element-311" />
          LOAN ORIGINATOR ROADMAP
        </h2>
      </div>

      <div className="px-6 pt-8 pb-6 overflow-x-auto" data-id="element-312">
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-x-6 gap-y-10 min-w-[1000px]" data-id="element-313">
          {/* Tier 1 */}
          <RoadmapTier number={1} title="LOAN PARTNER" subtitle="(Developmental) 0-6 Months" icon={<GraduationCap className="w-6 h-6" data-id="element-315" />} colorClass="text-blue-500" bgHeaderClass="bg-blue-400" requirements={<div className="flex items-center gap-2 text-sm font-medium text-gray-700" data-id="element-316">
                <div className="w-5 h-5 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center shrink-0" data-id="element-317">
                  <span className="text-xs font-bold" data-id="element-318">✓</span>
                </div>
                Pass and Study for NMLS Safe Exam
              </div>} focusItems={['Learn systems and processes', 'Support Loan Officers', 'Understand loan products']} compTiers={[{
          units: 'Base',
          bps: 60
        }, {
          units: '4+ Units',
          bps: 65,
          bonus: 5
        }, {
          units: '6+ Units',
          bps: 80,
          bonus: 20
        }, {
          units: '10+ Units',
          bps: 90,
          bonus: 30
        }]} goal="GET LICENSED" goalSub="& START CLOSING" data-id="element-314" />

          {/* Tier 2 - Current */}
          <RoadmapTier number={2} title="LOAN OFFICER" icon={<User className="w-6 h-6" data-id="element-320" />} isActive={true} colorClass="text-blue-600" bgHeaderClass="bg-blue-600" requirements={<ul className="space-y-1.5" data-id="element-321">
                <li className="flex items-center gap-2 text-xs font-medium text-gray-700" data-id="element-322">
                  <div className="w-4 h-4 rounded-full bg-blue-600 text-white flex items-center justify-center shrink-0 text-[10px]" data-id="element-323">
                    ✓
                  </div>
                  Pass Safe Exam
                </li>
                <li className="flex items-center gap-2 text-xs font-medium text-gray-700" data-id="element-324">
                  <div className="w-4 h-4 rounded-full bg-blue-600 text-white flex items-center justify-center shrink-0 text-[10px]" data-id="element-325">
                    ✓
                  </div>
                  Complete State Education
                </li>
                <li className="flex items-center gap-2 text-xs font-medium text-gray-700" data-id="element-326">
                  <div className="w-4 h-4 rounded-full bg-blue-600 text-white flex items-center justify-center shrink-0 text-[10px]" data-id="element-327">
                    ✓
                  </div>
                  Obtain Required Licenses
                </li>
              </ul>} focusItems={['Build Your Pipeline', 'Increase Conversions', 'Consistent Closings']} compTiers={[{
          units: 'Base',
          bps: 80
        }, {
          units: '4+ Units',
          bps: 85,
          bonus: 5
        }, {
          units: '6+ Units',
          bps: 100,
          bonus: 20
        }, {
          units: '10+ Units',
          bps: 110,
          bonus: 30
        }]} goal="BUILD YOUR PIPELINE." goalSub="CLOSE LOANS. GROW CONSISTENTLY." data-id="element-319" />

          {/* Tier 3 - Next */}
          <RoadmapTier number={3} title="SENIOR LOAN OFFICER" icon={<TrendingUp className="w-6 h-6" data-id="element-329" />} isNext={true} colorClass="text-[#0a1e5e]" bgHeaderClass="bg-[#0a1e5e]" requirements={<div className="flex items-center justify-between gap-2" data-id="element-330">
                <div className="flex flex-col items-center text-center flex-1" data-id="element-331">
                  <Calendar className="w-6 h-6 text-[#0a1e5e] mb-1" data-id="element-332" />
                  <span className="text-xs font-bold text-[#0a1e5e] leading-tight" data-id="element-333">
                    2 YEARS
                    <br data-id="element-334" />
                    TENURE
                  </span>
                </div>
                <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-[10px] font-bold text-gray-500 shrink-0" data-id="element-335">
                  OR
                </div>
                <div className="flex flex-col items-center text-center flex-1" data-id="element-336">
                  <BarChart2 className="w-6 h-6 text-[#0a1e5e] mb-1" data-id="element-337" />
                  <span className="text-xs font-bold text-[#0a1e5e] leading-tight" data-id="element-338">
                    16 UNITS
                    <br data-id="element-339" />
                    <span className="text-[9px] font-medium" data-id="element-340">IN ANY 4 MO</span>
                  </span>
                </div>
              </div>} focusItems={['Consistent High Production', 'Strong Pipeline Management', 'Advanced Deal Structuring', 'Maximize Efficiency & Results']} compTiers={[{
          units: 'Base',
          bps: 85
        }, {
          units: '4+ Units',
          bps: 90,
          bonus: 5
        }, {
          units: '6+ Units',
          bps: 105,
          bonus: 20
        }, {
          units: '10+ Units',
          bps: 115,
          bonus: 30
        }]} goal="ELEVATE YOUR PRODUCTION." goalSub="LEAD BY EXAMPLE." data-id="element-328" />

          {/* Tier 4 */}
          <RoadmapTier number={4} title="EXECUTIVE LOAN OFFICER" icon={<Award className="w-6 h-6" data-id="element-342" />} colorClass="text-orange-500" bgHeaderClass="bg-orange-500" requirements={<div className="flex items-center justify-between gap-2" data-id="element-343">
                <div className="flex flex-col items-center text-center flex-1" data-id="element-344">
                  <Calendar className="w-6 h-6 text-orange-500 mb-1" data-id="element-345" />
                  <span className="text-xs font-bold text-orange-500 leading-tight" data-id="element-346">
                    1 YEAR
                    <br data-id="element-347" />
                    <span className="text-[9px] font-medium" data-id="element-348">AS SENIOR LO</span>
                  </span>
                </div>
                <div className="w-8 h-8 rounded-full bg-orange-100 flex items-center justify-center text-[10px] font-bold text-orange-600 shrink-0" data-id="element-349">
                  AND
                </div>
                <div className="flex flex-col items-center text-center flex-1" data-id="element-350">
                  <BarChart2 className="w-6 h-6 text-orange-500 mb-1" data-id="element-351" />
                  <span className="text-xs font-bold text-orange-500 leading-tight" data-id="element-352">
                    26 UNITS
                    <br data-id="element-353" />
                    <span className="text-[9px] font-medium" data-id="element-354">IN ANY 6 MO</span>
                  </span>
                </div>
              </div>} focusItems={['Elite Level Production', 'Drive Results', 'High-Level Relationships', 'Operate at the Highest Level']} compTiers={[{
          units: 'Base',
          bps: 90
        }, {
          units: '4+ Units',
          bps: 95,
          bonus: 5
        }, {
          units: '6+ Units',
          bps: 110,
          bonus: 20
        }, {
          units: '10+ Units',
          bps: 120,
          bonus: 30
        }]} goal="DOMINATE YOUR MARKET." goalSub="BUILD A LASTING LEGACY." data-id="element-341" />
        </div>
      </div>
    </motion.div>;
}